import { render } from "./eb-radio-group.vue?vue&type=template&id=2ef3eaef"
import script from "./eb-radio-group.vue?vue&type=script&lang=ts"
export * from "./eb-radio-group.vue?vue&type=script&lang=ts"
script.render = render

export default script